
import 'slick-carousel';


;(function($) {

    $(document).ready(function() {

        $(".post-list.carousel.simple .posts .wp-block-group").slick({
            slidesToShow: 3,
            infinite: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                  breakpoint: 782,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $(".post-list.carousel.home_page_carousel .posts .wp-block-group").slick({
            slidesToShow: 3,
            infinite: true,
            responsive: [
                {
                  breakpoint: 782,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
     
    });
}(jQuery));